const eventsCommonNames = {
	userRedirected: 'web-user-redirect-ai',
	feedbackModalShown: 'feedback-modal-ai-view',
};

export default eventsCommonNames;
